const processDeviationMeasures = (list, transData) => {
  let getContent = ''
  for (let j = 0; j < list.length; j++) {
    getContent += `<tr>
      <th colspan="5" class="th-fontsize" style="background-color: #f5f5f5;">${transData.deviation}</th>
    </tr>`
    getContent += `<tr>
      <td colspan="5">${list[j].deviation_number || ''} ${list[j].deviation_title || ''}</td>
    </tr>`
    getContent += `<tr>
      <th colspan="3" class="th-fontsize" style="background-color: #f5f5f5;">${transData.measure}</th>
      <th colspan="2" class="th-fontsize" style="background-color: #f5f5f5;">${transData.header.category}</th>
    </tr>`
    getContent += `<tr>
      <td colspan="3">${list[j].title || ''}</td>
      <td colspan="2">${list[j].measure_category_name || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.measureIncharge}</th>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 15%;">${transData.measureDeadline}</th>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 25%;">${transData.measureStatus}</th>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 15%;">${transData.header.internalCost}</th>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 15%;">${transData.header.customerCost}</th>
    </tr>`
    getContent += `<tr>
      <td style="width: 30%;">${list[j].inchargeuser_name || ''}</td>
      <td style="width: 15%;">${list[j].deadline || ''}</td>
      <td style="width: 25%;">${list[j].status_name || ''}</td>
      <td style="width: 15%;">${list[j].estimatedinternalcost || ''}</td>
      <td style="width: 15%;">${list[j].estimatedcustomercost || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.description}</th>
      <td colspan="4" style="width: 70%;">${list[j].description || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.reason}</th>
      <td colspan="4" style="width: 70%;">${list[j].reason || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.underlyingReason}</th>
      <td colspan="4" style="width: 70%;"> ${list[j].underlying_reason || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.actions}</th>
      <td colspan="4" style="width: 70%;"> ${list[j].actions || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.correctiveActions}</th>
      <td colspan="4" style="width: 70%;"> ${list[j].corrective_actions || ''}</td>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize" style="background-color: #f5f5f5; width: 30%;">${transData.effectiveOfMeasures}</th>
      <td colspan="4" style="width: 70%;"> ${list[j].effective_of_measures || ''}</td>
    </tr>`

    if (j < (list.length - 1)) {
      getContent += `<tr>
        <td colspan="12"></td>
      </tr>`
    }
  }
  return content(getContent, transData)
}
const content = (content, transData) => btoa(unescape(encodeURIComponent(`
<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" />
<meta charset="utf-8"/>
<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
<style>
  .wrapContent { word-break: break-all; }
  table {
    border-collapse: collapse;
  }
  td, th {
    border: 1px solid black;
  }
</style>
</head>
<body>
<div class="container">
  <table class="table">
    <tbody>
      <tr height="60px">
        <td align="center" style="border: none !important;vertical-align: middle;">
          <div>
          <img height="40" width="140" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
          </div>
        </td>
        <td align="right" style="border: none !important;vertical-align: middle !important;" width="100%">
        </td>
      </tr>
    </tbody>
  </table>
  <table class="table table-bordered" style="width: 100%">
    <tbody>
      ${content}
    </tbody>
  </table>
</div>
</body></html>`)))
export default processDeviationMeasures
